import { useRollbarPerson } from '@rollbar/react';
import { useAppSelector } from '@app/store';

export const RollbarPersonProvider = () => {
  const currentUser = useAppSelector((store) => store.auth.user);
  useRollbarPerson(currentUser ?? {});
  return null;
};
